<template>
    <div>
        <div class="content">
            <el-row type="flex" align="bottom" style="width: 1200px;margin: auto;">
                <el-col :span="12" align="left" style="height: 150px;">
                    <div class="title">新闻动态</div>
                    <div class="text">了解中创远泰，了解行业前沿资讯</div>
                </el-col>
                <el-col :span="12" align="left">
                    <img class="img" src="../../../assets/images/news.png"/>
                </el-col>
            </el-row>
        </div>
        <div class="detailsBox" v-loading="loading">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div v-loading="loading" class="contentBody">
            <div v-if="text">
                <div class="title">{{title}}</div>
                <div class="time">{{time}}</div>
<!--                <div class="subtitle">{{subtitle}}</div>-->
                <div v-html="text" style="text-align: left;"></div>
            </div>
            <div v-if="!text && !loading">
                <el-row align="middle">
                    <el-col :span="10" style="margin-top: 15%; text-align: center;">
                        <h1>什么都没有找到</h1>
                        <div>
                            没有可以查看的动态信息！！！
                        </div>
                    </el-col>
                    <el-col :span="14">
                        <img src="../../../assets/images/empty.gif">
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import { getArticle } from '@/api/api'

export default {
    name: 'detailsModal',
    data () {
        return {
            loading: false,
            title: null,
            time: null,
            text: null,
            subtitle: null,
            id: null
        }
    },
    mounted () {
        console.log(this.$route.query)
        if (this.$route.query && this.$route.query.id) {
            this.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        loadData () {
            getArticle({articleId: this.id}).then(res => {
                if (res.data.success) {
                    let result = res.data.result
                    if (result && result.body) {
                        this.title = result.title
                        this.time = result.createTime ? result.createTime.substring(0, 10) : ''
                        this.subtitle = result.subtitle
                        this.text = this.unescape(result.body)
                    } else {
                        this.text = ''
                    }
                }
            }).finally(() => {
                this.loading = false
            })
        },
        unescape (html) {
            return html.replace(html ? /&(?!#?\w+;)/g : /&/g, '&amp;')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, '\'')
                .replace(/l&amp;nbsp;/g, '\u00A0')
                .replace(/&amp;nbsp;/g, '\u00A0')
        }
    }
}
</script>

<style lang="scss" scoped>
    .content {
        padding-top: 90px;
        background-color: #31b98b;
        .title{
            font-size: 36px;
            color: #ffffff;
            font-weight: bold;
            line-height: 40px;
            font-style: italic;
        }
        .text{
            font-size: 24px;
            color: #ffffff;
            line-height: 40px;
            margin-top: 20px;
            font-weight: 300;
        }
        .img{
            display: block;
            width: 500px;
        }
    }
    .detailsBox {
        width: 1200px;
        margin: 0 auto;
        padding: 30px 0;

        .el-menu-vertical-demo {
            margin-top: 30px;
            text-align: left;

            .el-icon-menu {

            }

            .title {
                text-align: left;
            }
        }
    }
    .contentBody {
        min-height: 50vh;
        width: 1200px;
        margin: 0 auto;
        background: #ffffff;
        padding: 30px;
        .title{
            font-size: 40px;
            font-weight: bold;
            color: #333333;
            padding: 40px 0;
        }
        .time{
            font-size: 12px;
            color: #999999;
            text-align: right;
            padding: 20px;
        }
        .subtitle{
            text-align: left;
            text-indent:40px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/news/modules/detailsModal.vue